import * as z from 'zod';
import { Data as Data$1, Close as Close$1 } from './bid-contract-surety-bond.types.mjs';
import * as bidContractSuretyBond_types from './bid-contract-surety-bond.types.mjs';
export { bidContractSuretyBond_types as Bid };
import { Data as Data$2, Close as Close$2 } from './final-contract-surety-bond.types.mjs';
import * as finalContractSuretyBond_types from './final-contract-surety-bond.types.mjs';
export { finalContractSuretyBond_types as Final };

var Data;
(function (Data) {
    Data.schema = z.discriminatedUnion("contractSuretyType", [
        Data$1.schema,
        Data$2.schema,
    ]);
})(Data || (Data = {}));
var Close;
(function (Close) {
    (function (Payload) {
        Payload.schema = z.discriminatedUnion("contractSuretyType", [
            Close$1.Payload.schema,
            Close$2.Payload.schema,
        ]);
    })(Close.Payload || (Close.Payload = {}));
})(Close || (Close = {}));

export { Close, Data };
